
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import RealTalk from "../pages/realtalk/page";
import Reviews from "../pages/reviews/page";
import Mining from "../pages/mining/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import Privacy from "../pages/privacy/page";
import Terms from '../pages/terms/page';
import Taktik from '../pages/taktik/page';
import Blog from '../pages/blog/page';
import MistplayStrategie from '../pages/blog/mistplay-strategie/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/realtalk",
    element: <RealTalk />,
  },
  {
    path: "/reviews",
    element: <Reviews />,
  },
  {
    path: "/mining",
    element: <Mining />,
  },
  {
    path: "/taktik",
    element: <Taktik />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/mistplay-strategie",
    element: <MistplayStrategie />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
